export const EMBEDDED_HOTEL_VIDEO_TEST_ID = 'EMBEDDED_HOTEL_VIDEO';
